// extracted by mini-css-extract-plugin
module.exports = {"botonAzul":"Finanzas_botonAzul__eYSzp","card":"Finanzas_card__1jCBn","Red":"Finanzas_Red__1zRlY","Yellow":"Finanzas_Yellow__3qMcZ","Green":"Finanzas_Green__3LXTe"};